/* SAHINKAYA_GUNCELLEMESI — max-1-per-cart enforcement
 *
 * <product-form data-max-one-per-cart="true" data-variant-id="X"> taşıyan
 * formlarda: cart'ta variant zaten varsa submit'i engelle + toast göster.
 * cart:change / cart:refresh event'leriyle buy button durumunu live update et.
 *
 * Bu dosya tag tabanlı çalışır — sadece 'max-1-per-cart' tag'i taşıyan
 * ürünlerin product form'una data attribute basılır (bkz.
 * snippets/buy-buttons.liquid).
 *
 * Pattern: refreshAllForms() cart'tan quantity'yi async olarak çeker ve
 * her form'a data-in-cart="true|false" attribute set eder. Submit listener
 * bu cached attribute'u sync olarak okur, fetch loop'una girmez.
 */
(function () {
  'use strict';

  var MAX_TAG_ATTR = 'data-max-one-per-cart';
  var VARIANT_ATTR = 'data-variant-id';
  var IN_CART_ATTR = 'data-in-cart';
  var BOUND_FLAG = 'maxOneBound';
  var ORIG_LABEL_FLAG = 'maxOneOriginalLabel';
  var DISABLED_LABEL = 'Sepette mevcut';
  var TOAST_MESSAGE = 'Bu ürün sepetinizde zaten var. Maksimum 1 adet eklenebilir.';

  function getMaxOneForms() {
    return document.querySelectorAll('product-form[' + MAX_TAG_ATTR + '="true"]');
  }

  function shopifyRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function fetchCart() {
    return fetch(shopifyRoot() + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (res) { return res.json(); });
  }

  function showToast(message) {
    try {
      window.dispatchEvent(new CustomEvent('toast:show', {
        detail: { message: message, type: 'warning' }
      }));
    } catch (_) {}

    var existing = document.querySelector('.max-one-toast');
    if (existing) existing.remove();

    var div = document.createElement('div');
    div.className = 'max-one-toast';
    div.setAttribute('role', 'status');
    div.textContent = message;
    div.style.cssText = [
      'position:fixed',
      'bottom:24px',
      'left:50%',
      'transform:translateX(-50%)',
      'background:#222',
      'color:#fff',
      'padding:12px 18px',
      'border-radius:8px',
      'z-index:9999',
      'font-size:14px',
      'max-width:90vw',
      'text-align:center',
      'box-shadow:0 4px 12px rgba(0,0,0,0.2)'
    ].join(';');
    document.body.appendChild(div);
    setTimeout(function () { if (div.parentNode) div.parentNode.removeChild(div); }, 3500);
  }

  function updateButtonState(productForm, alreadyInCart) {
    productForm.setAttribute(IN_CART_ATTR, alreadyInCart ? 'true' : 'false');

    var btn = productForm.querySelector('button[type="submit"], [type="submit"]');
    if (!btn) return;

    if (alreadyInCart) {
      btn.setAttribute('disabled', 'disabled');
      if (!btn.dataset[ORIG_LABEL_FLAG]) {
        btn.dataset[ORIG_LABEL_FLAG] = btn.textContent.trim();
      }
      btn.textContent = DISABLED_LABEL;
    } else {
      btn.removeAttribute('disabled');
      if (btn.dataset[ORIG_LABEL_FLAG]) {
        btn.textContent = btn.dataset[ORIG_LABEL_FLAG];
      }
    }
  }

  function refreshAllForms() {
    var forms = getMaxOneForms();
    if (!forms.length) return Promise.resolve();

    return fetchCart().then(function (cart) {
      var items = cart && cart.items ? cart.items : [];
      var qtyByVariant = {};
      items.forEach(function (i) { qtyByVariant[String(i.variant_id)] = i.quantity; });
      forms.forEach(function (form) {
        var vid = form.getAttribute(VARIANT_ATTR);
        if (!vid) return;
        var qty = qtyByVariant[String(vid)] || 0;
        updateButtonState(form, qty > 0);
      });
    }).catch(function () { /* no-op */ });
  }

  function bindSubmitGuards() {
    getMaxOneForms().forEach(function (productForm) {
      var formEl = productForm.querySelector('form');
      if (!formEl || formEl.dataset[BOUND_FLAG]) return;
      formEl.dataset[BOUND_FLAG] = '1';

      // Sync guard: cached attribute'u oku, fetch yapma → resubmit loop yok
      formEl.addEventListener('submit', function (e) {
        if (productForm.getAttribute(IN_CART_ATTR) === 'true') {
          e.preventDefault();
          e.stopImmediatePropagation();
          showToast(TOAST_MESSAGE);
          updateButtonState(productForm, true);
        }
      }, true); // capture: theme.js'in ProductForm handler'ından önce çalış
    });
  }

  function init() {
    bindSubmitGuards();
    refreshAllForms();
    window.addEventListener('cart:change', refreshAllForms);
    window.addEventListener('cart:refresh', refreshAllForms);
    window.addEventListener('variant:add', refreshAllForms);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
